"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BodyPartCategory = void 0;
const validation_1 = require("../../../validation");
var BodyPartCategory;
(function (BodyPartCategory) {
    BodyPartCategory["HEAD"] = "head";
    BodyPartCategory["HANDS"] = "hands";
})(BodyPartCategory = exports.BodyPartCategory || (exports.BodyPartCategory = {}));
(function (BodyPartCategory) {
    BodyPartCategory.schema = {
        type: 'string',
        enum: Object.values(BodyPartCategory)
    };
    BodyPartCategory.validate = (0, validation_1.generateLazyValidator)(BodyPartCategory.schema);
})(BodyPartCategory = exports.BodyPartCategory || (exports.BodyPartCategory = {}));
//# sourceMappingURL=body-part-category.js.map